import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, RaikoMaterialOutlinedInput, RaikoMobileInputOutlined, RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoToggleOutlined, showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {FundService} from "../../../serverService/fund/FundService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {stringIsEmpty} from "../../../util/VariableChecker";

export default function FundAdminDetailBasicInfo({selectedFunds}) {

    const {id: adminId = -1} = useParams()

    const service = new FundService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [nationalCode, setNationalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [enabled, setEnabled] = useState(false);

    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");


    useEffect(() => {
        getDataFromServer()
    }, []);

    function getDataFromServer() {
        loading.show()
        service.getFundAdminDetail(adminId)
            .then(response => {
                setFirstName(response.firstName)
                setLastName(response.lastName)
                setUsername(response.username)
                setPhoneNumber(response.phoneNumber)
                setNationalCode(response.nationalCode)
                setEnabled(response.enabled)

                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setCreatedBy(response.createdByAdmin)
                selectedFunds([{
                    id: response.fundId,
                    name: response.fundName
                }])

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateInfo() {
        if (checkFields()) {
            loading.show()
            service.updateFundAdmin(
                adminId,
                firstName,
                lastName,
                nationalCode,
                phoneNumber,
                username,
                password,
                enabled
            ).then(response => {
                showSuccessMessage("بروزرسانی اطلاعات با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let message
        let state = false

        if (stringIsEmpty(firstName))
            message = "لطفا نام مدیر را وارد نمایید."
        else if (stringIsEmpty(lastName))
            message = "لطفا نام خانوادگی مدیر را وارد نمایید."
        else if (!nationalCode || nationalCode.length < 8 || nationalCode.length > 11)
            message = "لطفا شماره ملی مدیر را به درستی وارد نمایید."
        else if (!phoneNumber || phoneNumber.length !== 11)
            message = "لطفا شماره همراه مدیر را به درستی وارد نمایید."
        else if (stringIsEmpty(username))
            message = "لطفا نام کاربری مدیر را وارد نمایید."
        else if (password && (password.length !== 0 && password.length < 8))
            message = "رمز عبور حداقل می بایست ۸ کاراکتر باشد."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateInfo}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridThreeColumn>
                            <RaikoMaterialOutlinedInput
                                labelText={"نام"}
                                value={firstName}
                                setValue={setFirstName}
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"نام خانوادگی"}
                                value={lastName}
                                setValue={setLastName}
                            />
                            <RaikoNumberInputOutlined
                                labelText={"کدملی"}
                                value={nationalCode}
                                setValue={value => {
                                    if (!value || value.length < 11)
                                        setNationalCode(value)
                                }}
                            />
                            <RaikoMobileInputOutlined
                                labelText={"شماره همراه"}
                                value={phoneNumber}
                                setValue={setPhoneNumber}
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"نام کاربری"}
                                value={username}
                                setValue={setUsername}
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"رمز عبور"}
                                value={password}
                                setValue={setPassword}
                            />
                            <RaikoToggleOutlined
                                checked={enabled}
                                setChecked={setEnabled}
                                labelText={"فعال/غیرفعال"}
                            />
                        </RaikoGridThreeColumn>
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoCreatorInfo createdAt={createdAt} createdBy={createdBy}/>
        </RaikoGridOneColumn>
    )
}
